<template>
  <tr @click.stop="toggleActive" :class="computedClasses" :style="isExpired">
    <td v-if="hasCheckbox" style="border-right:1px solid #C4C4C4;padding: 0 10px">
      <AppCheckbox :checked="isActive"
                   @toggle-check="toggleActive"/>
    </td>

    <td v-if="hasCount">{{count}}</td>

    <td
      v-for="(item, index) in values"
      :key="index"
      :class="item.mod"
      @click.stop="showItem"
      :colspan="item.isColspan ? item.colspan : ''"
    >

      <div class="cell-inner" v-if="item.mod === 'colorCell'">
        <span class="cell-data colorCell-item" :style="`background-color: ${ item.data }`"></span>
      </div>

      <div class="cell-inner" v-else-if="item.mod === 'avatar'">
        <span style="display:flex; align-items: center">
          <div class="user-avatar dialog-avatar" style="margin-right:12px">
            <img v-if="item.data.avatar"
                :src="item.data.avatar.url" :alt="item.data.avatar.full_name">
            <img v-else src="/img/avatar-thumb.png">
          </div>

          <div v-if="item.data && item.data.profile">
            {{ item.data.profile.full_name }}
          </div>
        </span>
      </div>

      <div v-else-if="item.mod === 'status'">
        <div v-if="item.data.status">
          {{ item.data.status.name }}
        </div>
          <div class="line-status online" v-if="item.data.difference_auth_at && item.data.difference_auth_at < 300">online</div>
          <div class="line-status offline" v-else>offline</div>
      </div>

      <div class="cell-inner" v-else-if="item.mod === 'colorText'">
        <span class="cell-data colorText" :style="`color: ${ item.data.color }`">{{item.data.name}}</span>
      </div>

      <div class="cell-inner" v-else-if="item.mod === 'pvhComments'">
        <span class="cell-data">{{ item.data[0] }}</span>
        <span class="cell-data" style="display: block; width: max-content; font-size: 12px;" v-if="item.data[1]">{{ item.data[1] }}</span>
      </div>

      <div class="cell-inner" v-else-if="item.mod === 'fuel'">
        <p class="cell-data" style="font-size: 12px;" v-for="fuel in item.data" :key="fuel.id">
          <strong>{{fuel.fuel.name}}:</strong> {{fuel.balance_at}}/{{fuel.balance_to}}
        </p>
      </div>

      <div class="cell-inner" v-else-if="item.mod === 'countFiles'">
        <span style="margin-right: 8px">
          <svg width="17" height="13" viewBox="0 0 17 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 0H8.5V2.5H17V13H0V0Z" fill="#FAB959"/>
          </svg>
        </span>
        <span>{{item.data.count}}</span>
      </div>

      <div class="cell-inner" v-else-if="item.mod === 'countFileslenght'" >
        <span style="margin-right: 6px">
          <svg width="17" height="13" viewBox="0 0 17 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 0H8.5V2.5H17V13H0V0Z" fill="#FAB959"/>
          </svg>
        </span>
        <span v-if="item.data">
          {{item.data.length}} файл(ов)</span>
        <span v-else>0 файлов</span>
      </div>

      <div class="cell-inner" v-else-if="item.mod === 'innerHTML'">
        <span
          class="cell-data"
          v-html="typeof item === 'object' ? item.data || '-' : item || '-'"
        />
      </div>

      <div class="cell-inner cell-inner--many" v-else-if="item.mod === 'many'">
        <span
          class="cell-data cell-data--many"
          v-for="(item, i) of item.data"
          :key="i"
        >
          {{ item }}
        </span>
      </div>

      <div class="cell-inner" v-else-if="item.mod === 'date'">
        <span class="cell-data">{{  (item.data || '-') | dateFilter }}</span>
      </div>

      <div class="cell-inner" v-else-if="item.mod === 'comments'">
        <span class="cell-comments">
          {{  (item.data || '-') | dateFilter }}
        </span>
      </div>

      <div class="cell-inner" v-else-if="item.mod === 'date-simple'">
        <span class="cell-data">{{  (item.data || '-') | simpleDate }}</span>
      </div>

      <div class="cell-inner" v-else-if="item.mod === 'orders-count'">
        <span style="margin-right: 6px">
          <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 1H6" stroke="#0E619F" stroke-width="2"/>
            <path d="M0 6H10" stroke="#0E619F" stroke-width="2"/>
          </svg>
        </span>
        <span v-if="item.data">
          {{item.data}} заявок</span>
        <span v-else>0 заявок</span>
      </div>

      <div class="cell-inner" v-else-if="item.mod === 'select'">
        <VSelect
          :value="item.data !== '-' ? item.data : null"
          :name="item.name"
          :items="item.list"
          @change="(value) => onSelect({
            value,
            name: item.name,
            refresh: item.refresh
          })"
        />
      </div>

      <div v-else-if="item.mod === 'file-link'" class="cell-inner">
        <a class="link" :href="item.src" target="_blank" @click.stop>{{ item.text }}</a>
      </div>

      <TableModLinks
        v-else-if="item.mod === EAppTableMod.links"
        :data="item.data"
        :get-route-handler="item.getRouteHandler"
      />

      <div class="cell-inner" v-else>
        <span class="cell-data">{{ typeof item === 'object' ? item.data || '-' : item || '-' }}</span>
      </div>
    </td>

    <td class="table__menu-cell" v-if="isMenuControlsActive">
      <div>
        <div class="table__menu" @click="toggleControls">
          <svg class="ellipsis-icon" viewBox="0 0 23 4" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="2" cy="2" r="2" fill="currentColor"/>
            <circle cx="11" cy="2" r="2" fill="currentColor"/>
            <circle cx="21" cy="2" r="2" fill="currentColor"/>
          </svg>
        </div>
        <div class="table__controls">
          <transition name="fade">
            <AppPopupControls v-if="isControlsActive"
                              :active-buttons="{add: menuControls.add, edit: menuControls.update, remove: menuControls.remove}"
                              @edit-this-item="editItem"
                              @remove-this-item="removeItem"
            />
          </transition>
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
import AppPopupControls from '../popup/AppPopupControls.vue'
import AppCheckbox from '@/components/page/input/AppCheckbox'
import VSelect from '@/components/page/Form/VSelect.vue'
import TableModLinks from './mod/TableModLinks.vue'
import { EAppTableMod } from './types'

export default {
  name: 'app-table-special-elem',
  components: {
    TableModLinks,
    AppPopupControls,
    AppCheckbox,
    VSelect
  },
  props: {
    hasCheckbox: {
      type: Boolean,
      default: false
    },
    isActive: Boolean,
    isWarning: Boolean,
    isDeactive: Boolean,
    isControlsActive: Boolean,
    isMenuControlsActive: {
      type: Boolean,
      default: true
    },
    menuControls: {
      type: Object,
      default: () => ({
        add: false,
        update: true,
        remove: true
      })
    },
    itemId: {
      type: [Number, String]
    },
    values: {
      type: Array,
      default: () => []
    },

    hasCount: {
      type: Boolean,
      default: false
    },

    count: {
      type: Number,
      default: 0
    }
  },
  data: () => ({
    EAppTableMod
  }),
  computed: {
    computedClasses () {
      return {
        tr_active: this.isActive,
        tr_warning: this.isWarning,
        tr_deactive: this.isDeactive
      }
    },
    isExpired () {
      const status = this.values.find(item => item === 'ПРОСРОЧЕН' || item === 'Срок истекает')

      if (status && status !== 1) {
        return {
          color: status === 'ПРОСРОЧЕН' ? '#EF424D' : '#FAAB59'
        }
      }

      return {}
    }
  },
  methods: {
    toggleControls () {
      this.$emit('toggle-controls')
    },
    toggleActive () {
      this.$emit('toggle-active')
    },
    editItem () {
      this.$emit('edit-this-item')
    },
    removeItem () {
      this.$emit('remove-this-item')
    },
    showItem () {
      this.$emit('show-this-item')
    },
    showChildItem (itemId) {
      this.$emit('show-this-child-item', itemId)
    },
    onSelect (data) {
      this.$emit('onSelect', { ...data, id: this.itemId })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../../../assets/css/system/_vars';
  @import '../../../assets/css/system/_mixins';

  @import './_table';

  tr {
    cursor: pointer;
  }

  /* колличество дочерних задач в списке задач */
  .task-child-count .cell-inner {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .task-child-count .cell-data {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  // pvh
  .pvh-bold {
    font-weight: bold;
  }

  a.pvh-link {
    color: #204da9;

    &:hover {
      color: #ffd9a2;
      text-decoration: underline;
    }
  }

  .colorCell-item {
    width: 40px;
    height: 18px;
    display: block;
  }

  .online {
    color: $color_fourth;

    &:before {
      background: $color_fourth;
      background: $color_fourth_gradient;
    }
  }

  .offline {
    color: $color_fifth;

    &:before {
      background: $color_fifth;
      background: $color_fifth_gradient;
    }
  }

  .line-status {
    font-size: 14px;
    font-weight: bold;

    &:before {
      content: '';
      display: inline-block;
      width: 9px;
      height: 9px;
      border-radius: 50%;
      margin-right: 6px;
    }
  }

  .cell-inner {

    &--many {
      display: flex;
      flex-direction: column;
    }
  }

  .cell-data {
    &--many:not(:last-child) {
      margin-bottom: 20px;
      //padding: 10px 0;
    }
  }
  .cell-comments {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
  }
</style>
